import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button';
import image6 from './images/image6.png';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 15px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const ImageHolder = styled(Flex)`
  flex-direction: column;
  padding-left: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 15px;
    width: 50%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row-reverse;
  display: flex;
  // padding: 2px;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const Heading = styled.div`
  font-size: 18px;
  font-weight: 900;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  padding-bottom: 24px;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 26px;
  }
`;

const Description = styled(Box)`
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #7c8788;
  padding-bottom: 24px;
`;

const ButtonContainer = styled(Flex)`
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: start;
  }
`;

export const Scaling1 = (): ReactElement => {
  return (
    <Container>
      <ContainerInner>
        <ImageHolder>
          <img alt="" src={image6} />
        </ImageHolder>
        <SubContainer>
          <Heading>
            Scaling professional learning for membership associations
          </Heading>
          <Description>
            In today’s ever-changing technological landscape, missing to update
            one’s professional knowledge is equivalent to remaining stagnant and
            simply waiting to be replaced. OpenLearning partnered with Relief
            Teacher Association to provide a solution for members to access a
            thriving professional learning network, on demand.{' '}
          </Description>
          <ButtonContainer>
            <Button
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/success-stories-classcover-relief-teacher-association-case-study/',
                target: '_blank',
              }}
            >
              Read full case study
            </Button>
          </ButtonContainer>
        </SubContainer>
      </ContainerInner>
    </Container>
  );
};
